import { render, staticRenderFns } from "./dataImport.vue?vue&type=template&id=9957d2cc&scoped=true&"
import script from "./dataImport.vue?vue&type=script&lang=js&"
export * from "./dataImport.vue?vue&type=script&lang=js&"
import style0 from "./dataImport.vue?vue&type=style&index=0&id=9957d2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9957d2cc",
  null
  
)

export default component.exports